const getHashNumber = (inputString: string, maxValue: number) => {
  let sum = 0;
  for (let i = 0; i < inputString.length; i++) {
    sum += inputString.charCodeAt(i);
  }

  return sum % maxValue;
};

/**
 * if the hexColor is dark -> return #ffffff else return #000000
 * @param hexColor : hex color
 */
const getFgFrombgColor = (hexColor: string) => {
  // @usage: rgbToHex(0, 51, 255) // #0033ff
  let rgbToHex = (r: number, g: number, b: number) => {
    return '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
  };

  //@usage: hexToRgb("#0033ff").g // 51
  let hexToRgb = (hex: string) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : {
          r: 0,
          g: 0,
          b: 0,
        };
  };

  let { r, g, b } = { ...hexToRgb(hexColor) };
  let isDark = r * 0.299 + g * 0.587 + b * 0.114 > 186;
  if (isDark) {
    return '#000000';
  } else {
    return '#ffffff';
  }
};

const getHashColor = (inputString: string) => {
  let color_palette = [
    '#264653',
    '#2a9d8f',
    '#e9c46a',
    '#f4a261',
    '#e76f51',
    '#001219',
    '#005f73',
    '#0a9396',
    '#94d2bd',
    '#e9d8a6',
    '#ee9b00',
    '#ca6702',
    '#bb3e03',
    '#ae2012',
    '#9b2226',
  ];
  let backgroundColor = color_palette[getHashNumber(inputString, color_palette.length)];
  let foregroundColor = getFgFrombgColor(backgroundColor);

  return { backgroundColor, foregroundColor };
};

export { getHashNumber, getHashColor };
